<template>
  <ion-page id="download-page">
    <ion-content >
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleDownload">
        <ion-item>
          <ion-input :label="lichessLabelString" label-placement="floating" 
                    :placeholder="placeHolderString" :value="lichessName"
                    @ionInput="lichessInputChange">
          </ion-input>
        </ion-item>
        <hr>
        <ion-item>
          <ion-input :label="chesscomLabelString" label-placement="floating" 
                    :placeholder="placeHolderString" :value="chesscomName" 
                    @ionInput="chesscomInputChange">
          </ion-input>
        </ion-item>

        <br>
        <ion-item>
          <div :class="{ 
                  'text-light' : isDark,
                  'text-dark' : !isDark, 
                  'repselector-center-text' : true ,
                  'repselector-heading-color' : true }" >
            <b>Lichess</b> {{ lichessDownloadStatus }} {{  lichessDownloadString }}
          </div>
        </ion-item>
        <ion-item>
          <div :class="{ 
                  'text-light' : isDark,
                  'text-dark' : !isDark, 
                  'repselector-center-text' : true ,
                  'repselector-heading-color' : true }" >
              <b>Chess.com</b> {{ chesscomDownloadStatus }} {{  chesscomDownloadString }}
          </div>
        </ion-item>
        <ion-item>
          <div v-if="showWaiting" >
            <div :class="{ 
                    'text-light' : isDark,
                    'text-dark' : !isDark, 
                    'repselector-center-text' : true ,
                    'repselector-heading-color' : true }" >
                {{ t("# of moves waiting for score") }} ({{ t("refresh in") }} {{ waitingSeconds }} {{ t("secs") }}) -> 
                    {{ ((waitingCount == -1) ? '?' : waitingCount) }}
            </div>
          </div>
        </ion-item>
      </div>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                         @toolbar-click="toolbarClick"/>
  </ion-page>
</template>
 
<script setup>
 
   import { IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
 
   import Toolbar from '@/components/Toolbar.vue';
   import { t } from "@/composables/translateText.js";

   import { doStartupCheck } from '@/composables/startupCheck.js'
   import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

   import { watch, onMounted, onBeforeUnmount, ref } from "vue";
 
   import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                 from '@/composables/toolbarSupport.js'
   import { useConnectionStore } from '@/stores/connectionStore';
 
   import { useGetData , getLichessData, getChesscomData, 
              generateErrorAlertText } from '@/composables/getData.js'
    import { useWindowSizeStore } from '@/stores/windowSizeStore';
    import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
   const toolbarTrigger = ref(0)
 
   const connectionStore = useConnectionStore()
   const isDark = ref(connectionStore.getDarkmode != "light")

   const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

   // Download fields

  const TOOLBAR_DOWNLOAD_LICHESS = 0
  const TOOLBAR_DOWNLOAD_CHESSCOM = 1
  const toolbarElements = ref([
    { index : TOOLBAR_DOWNLOAD_LICHESS, label : t("Pull Lichess Games") ,disabled : true},
    { index : TOOLBAR_DOWNLOAD_CHESSCOM, label : t("Pull Chess.com Games") ,disabled : true},
    ])

  const lichessLabelString = ref("Lichess.com " + t("User Name"))
  const chesscomLabelString = ref("Chess.com " + t("User Name"))
  const placeHolderString = ref(t("Enter username"))

  const lichessName = ref("")
  var originalLichessName = ""
  const lichessDownloadString = ref("")
  var lichessDownloadTime = 0

  // time sent to lichess.org as based time to get games
  var lichessSinceTime = 0

  const lichessDownloadStatus = ref(t("pulled through"))

  const chesscomName = ref("")
  var originalChesscomName = ""
  const chesscomDownloadString = ref("")
  const chesscomDownloadStatus = ref(t("pulled through"))
  var chesscomDownloadYearMonth = 0
  var chesscomYearMonthList = []
  var chesscomYearMonthListIndex = 0

  const waitingCount = ref(-1)
  const waitingSeconds = ref(15)
  const showWaiting = ref(false)
  var waitingTimerIsRunning = false
  var waitingTimerCount = 0
  var timerId = null

  const styleDownload = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

   function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
     if (connectionStore.getIsSubscriber != 1) {
       return
     }
     updateWidthHeights()
   }
 
   doStartupCheck(false,afterStartupCallbackRoutine)
 
   onMounted(() => {
      getUserGameMetaData()
    })
 
    onBeforeUnmount(() => {
    if (timerId != null)
      clearInterval(timerId)
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
  })

  function updateStyleObjects(boundaries) {
    styleDownload.value.height = boundaries['download'].height + "px"
    styleDownload.value.width = boundaries['download'].width + "px"
    styleDownload.value.top = boundaries['download'].top + "px"
    styleDownload.value.left = boundaries['download'].left + "px"
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculateWidthHeights(availableSpace) :
                                      calculateWidthHeights(availableSpace)
    updateStyleObjects(boundaries)
  }

  function calculateWidthHeights(availableSpace) {

    const downloadPositionTop = 0
    const downloadPositionLeft = availableSpace.leftRightIndent
    const downloadHeight = availableSpace.height - downloadPositionTop
    const downloadWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { download : {
        width : downloadWidth,
        height : downloadHeight,
        left : downloadPositionLeft + availableSpace.leftIndent,
        top : downloadPositionTop+ availableSpace.topIndent
      }

    }
    return (result)
  }

   // ******** DOWNLOAD ROUTINES **********

  function startTimer() {
    if (waitingTimerIsRunning) {
      waitingTimerCount = 0
      waitingSeconds.value = 15
      return
    }

    showWaiting.value = true
    waitingTimerIsRunning = true

    function oneSecondInterval() {
      waitingSeconds.value -= 1
      if (waitingSeconds.value <= 0) {

        // first 4 times, sync every 15 seconds
        waitingSeconds.value = (waitingTimerCount < 4) ? 15 : 60
        waitingTimerCount++;
        getWaitingCount()
      }
    }
    timerId = setInterval(oneSecondInterval, 1000)
  }

  function setToolbarDownloadDisabled(status) {
    toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].disabled = status
    toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].disabled = status
    toolbarTrigger.value++
  }
  
  function toolbarClick(arrayIndex) {

    // trap that the button should be disabled but the screen hasn't caught up
    if (arrayIndex < 10 && toolbarElements.value[arrayIndex].disabled)
      return

    switch (arrayIndex) {
      case TOOLBAR_DOWNLOAD_LICHESS :
        if (originalLichessName != "" && lichessName.value == originalLichessName) {
          setToolbarDownloadDisabled(true)
          getLichessGames(true)
          startTimer()
        }
        else
          getLichessVerifyUser()
        break
      case TOOLBAR_DOWNLOAD_CHESSCOM :
        if (originalChesscomName != "" && chesscomName.value == originalChesscomName) {
          showWaiting.value = true
          setToolbarDownloadDisabled(true)
          getChesscomYearMonthList()
          startTimer()
        }
        else
          getChesscomVerifyUser()
        break
    }
  }

  function lichessInputChange(ev) {
    //console.log("lichess ",ev)
    const value = ev.target.value;
    //console.log("lichess name ",value)
    lichessName.value = value.trim()
    lichessNameChange()
  }

  function chesscomInputChange(ev) {
    //console.log("chess.com ",ev)
    const value = ev.target.value;
    //console.log("chess.com name ",value)
    chesscomName.value = value.trim()
    chesscomNameChange()
  }

  function lichessNameChange() {
    if (originalLichessName != "" && lichessName.value == originalLichessName) {
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].label = t("Pull Lichess Games")
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].disabled = false
      startTimer()
    }
    else
    if (lichessName.value == "") {
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].label = t("Enter Lichess Name")
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].disabled = true
    }
    else {
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].label = t("Verify Lichess Name")
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].disabled = false
    }

    toolbarTrigger.value++
  }

  function chesscomNameChange() {
    if (originalChesscomName != "" && chesscomName.value == originalChesscomName) {
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].label = t("Pull Chess.com Games")
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].disabled = false
      startTimer()
    }
    else
    if (chesscomName.value == "") {
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].label = t("Enter Chess.com Name")
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].disabled = true
    }
    else {
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].label = t("Verify Chess.com Name")
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].disabled = false
    }

    toolbarTrigger.value++
  }

  function processGetMetadataJsonResponse(json) {
    console.log(" in get meta callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    lichessName.value = json["lichess_name"]
    originalLichessName = lichessName.value
    if (originalLichessName == "") {
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].label = t("Enter Lichess Name")
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].disabled = true
    }
    else {
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].label = t("Pull Lichess Games")
      toolbarElements.value[TOOLBAR_DOWNLOAD_LICHESS].disabled = false
      lichessDownloadStatus.value = t("pulled through")
      lichessDownloadString.value = json["lichess_downstring"] + " (UTC)"
      startTimer()
    }

    lichessDownloadTime = json["lichess_downtime"]
    
    chesscomName.value = json["chesscom_name"]
    originalChesscomName = chesscomName.value

    chesscomDownloadYearMonth = json["chesscom_downyearmon"]
    const chesscomDownloadYear = Math.floor(chesscomDownloadYearMonth / 12)
    var chesscomDownloadMonth = (chesscomDownloadYearMonth % 12)

    // trap that the download month might be 1-12 based in current year
    const d = new Date();
    const currentMonth = d.getMonth()
    const currentYear = d.getFullYear()
    if (currentYear == chesscomDownloadYear && currentMonth < chesscomDownloadMonth)
      chesscomDownloadMonth = currentMonth
    console.log("****** chesscom Download ",chesscomDownloadYear,chesscomDownloadMonth)
    chesscomDownloadMonth++

    if (originalChesscomName == "") {
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].label = t("Enter Chess.com Name")
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].disabled = true
    }
    else {
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].label = t("Pull Chess.com Games")
      toolbarElements.value[TOOLBAR_DOWNLOAD_CHESSCOM].disabled = false
      chesscomDownloadStatus.value = t("pulled through")
      chesscomDownloadString.value = t("Year") + ": " +  chesscomDownloadYear + 
                                    " " + t("Month") + ":" + chesscomDownloadMonth
      startTimer()
    }

    toolbarTrigger.value++
  }

  function getUserGameMetaData() {
    var formData = { 
    }

    useGetData("chessvis_download_user_game_metadata.php", formData, processGetMetadataJsonResponse)
  }

  function processSetMetadataJsonResponse(json) {
    //console.log(" set meta data callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    getUserGameMetaData()
  }

  function setUserName(source,name) {
    var formData = { 
      source : source,
      newname : name
    }

    useGetData("chessvis_download_user_game_set_metadata.php", formData, processSetMetadataJsonResponse)
  }

  //////////////// CHECK ON WAITING COUNT ROUTINES ////////////

  function processWaitingCountJsonResponse(json) {
    //console.log(" get waiting count callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    waitingCount.value = json['count']
  }

  function getWaitingCount() {
    var formData = { 
    }

    useGetData("chessvis_download_future_move_waiting_count.php", formData, processWaitingCountJsonResponse)
  }

  //////////////// LICHESS ROUTINES ///////////

  function processLichessJsonResponse(gameText) {
    const firstChars = gameText.substring(0,100)
    //console.log(" in lichess game download callback",gameText.length,firstChars)

    if (gameText == "") {
      lichessDownloadStatus.value = t("All Done through") + ":"
      setToolbarDownloadDisabled(false)
      return
    }
    lichessDownloadStatus.value = t("Processing Games After") + ":"

    // send games to server
    sendLichessGamesToServer(gameText)

  }

  function getLichessGames(isFirstGet) {

    // if first get then backup a day to cover any timezone issues
    lichessSinceTime = (isFirstGet && lichessDownloadTime > 0) ? 
                        lichessDownloadTime - 24 * 3660 : lichessDownloadTime

     // time is in milliseconds so append 3 zeros

    const urlStr = "https://lichess.org/api/games/user/" + lichessName.value.toLowerCase() + 
            "?sort=dateAsc&since=" + lichessSinceTime + 
            "000&clocks=false&perfType=bullet,blitz,rapid,classical&max=500"

    //console.log("Lichess URL",urlStr)

    lichessDownloadStatus.value = t("Pulling Games After") + ":"
    getLichessData(urlStr, "pgn",null, processLichessJsonResponse) 
  }

  function processLichessGamesSentToServerJsonResponse(json) {
    //console.log(" in sent games to server callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const recent = json['recent']
    const recentString = json['recent_string']
    
    if (recent <= lichessSinceTime) {
      lichessDownloadStatus.value = t("All Done through") + ":"
      lichessDownloadString.value = recentString + " (UTC)"
      setToolbarDownloadDisabled(false)
    }
    else {
      lichessDownloadStatus.value = t("Pulling Games After") + ":"
      lichessDownloadString.value = recentString + " (UTC)"
      lichessDownloadTime = recent

      // get more games
      getLichessGames(false)
    }
  }

  function sendLichessGamesToServer(gameText) {
    const source = "lichess"

    var formData = { 
      source : "lichess",
      gametext : gameText,
      recent : 0
    }

    useGetData("chessvis_download_process_user_games.php", formData, processLichessGamesSentToServerJsonResponse)
  }

  function processLichessVerifyUserJsonResponse(json) {
    //console.log(" verify lichess player name callback",json)
    if (json.hasOwnProperty('error') || json.hasOwnProperty('id') == false) {
      lichessDownloadStatus.value = t("Name Doesn't Exist")
      return;
    }
    lichessDownloadStatus.value = t("Valid Name, Updating Record") + "..."
    lichessDownloadString.value = ""
    setUserName("lichess",lichessName.value)
  }

  function getLichessVerifyUser() {
    const urlStr = "https://lichess.org/api/user/" + lichessName.value.toLowerCase()
    getLichessData(urlStr,null, null, processLichessVerifyUserJsonResponse) 
  }

  //////////////// CHESS.COM  ROUTINES ////////////////////

  function processChesscomYearMonthJsonResponse(json) {
    //console.log("chesscom year month list callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    if (json.hasOwnProperty('archives') == false) {
      setToolbarDownloadDisabled(false)
      return
    }

    chesscomYearMonthList = json['archives']
    chesscomYearMonthListIndex = 0
        
    // find first year/month to get games for
    while (chesscomYearMonthListIndex < chesscomYearMonthList.length) {
      const urlPieces = chesscomYearMonthList[chesscomYearMonthListIndex].split("/")
      if (urlPieces.length > 2) {
        const year = urlPieces[urlPieces.length - 2]
        var month = urlPieces[urlPieces.length - 1]

        // month should be zero based. chess.com gives back 01-12
        if (month > 0)
          month--

        const yearMonth = year * 12 + month

        if (yearMonth < chesscomDownloadYearMonth) {
          chesscomYearMonthListIndex++
          continue
        }
        else
          break
      }
      chesscomYearMonthListIndex++
    }

    // if year/month in archive not already done, then get that month
    
    if (chesscomYearMonthListIndex < chesscomYearMonthList.length)
       getChesscomGames()
    else {
      const urlPieces = chesscomYearMonthList[chesscomYearMonthList.length-1].split("/")
      const year = urlPieces[urlPieces.length - 2]
      const month = urlPieces[urlPieces.length - 1]
      chesscomDownloadString.value = "Year: " +  year + " Month:" + month
      chesscomDownloadStatus.value = t("All Done through") + ":"
      setToolbarDownloadDisabled(false)
    }

  }

  function getChesscomYearMonthList() {
    const urlStr = "https://api.chess.com/pub/player/" + chesscomName.value.toLowerCase() + 
                    "/games/archives"

    chesscomDownloadStatus.value = t("Pulling Games After") + ":"
    console.log("chess.com pull game list ",urlStr)
    getChesscomData(urlStr,null, processChesscomYearMonthJsonResponse) 
  }

  function processChesscomGamesJsonResponse(gameText) {
    //console.log("chesscom games callback",gameText)
    console.log("Chesscom game text length", gameText.length)

    chesscomDownloadStatus.value = t("Pulling Games For") + ":"

    sendChesscomGamesToServer(gameText)
  }

  function getChesscomGames() {

    const urlPieces = chesscomYearMonthList[chesscomYearMonthListIndex].split("/")
    const year = urlPieces[urlPieces.length - 2]
    const month = urlPieces[urlPieces.length - 1]
    chesscomDownloadStatus.value = t("Pulling Games For") + ":"
    chesscomDownloadString.value = t("Year") + ": " +  year + " " + t("Month") + ":" + month

    const urlStr = chesscomYearMonthList[chesscomYearMonthListIndex] + "/pgn"

    console.log("get games ",urlStr)
    getChesscomData(urlStr,null, processChesscomGamesJsonResponse) 

  }

  function processChesscomGamesSentToServerJsonResponse(json) {
    //console.log(" in sent games to server callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
    
    chesscomYearMonthListIndex++

    if (chesscomYearMonthListIndex >= chesscomYearMonthList.length) {
      chesscomDownloadStatus.value = t("All Done through") + ":"
      setToolbarDownloadDisabled(false)
    }
    else {
      // get more games
      getChesscomGames()
    }
  }

  function sendChesscomGamesToServer(gameText) {
    const source = "chesscom"

    const urlPieces = chesscomYearMonthList[chesscomYearMonthListIndex].split("/")
    const year = Number(urlPieces[urlPieces.length - 2])
    var month = Number(urlPieces[urlPieces.length - 1])

    // month should be zero based. chess.com gives back 01-12
    if (month > 0)
      month--

    var formData = { 
      source : "chesscom",
      gametext : gameText,
      recent : year * 12 + month
    }

    //console.log("**** send games server.  recent-> ",formData.recent)

    useGetData("chessvis_download_process_user_games.php", formData, processChesscomGamesSentToServerJsonResponse)
  }

  function processChesscomVerifyUserJsonResponse(json) {
    //console.log(" verify chess.com player name callback",json)
    if (json.hasOwnProperty('error') || json.hasOwnProperty('player_id') == false) {
      chesscomDownloadStatus.value = t("Name Doesn't Exist")
      return;
    }
    chesscomDownloadStatus.value = t("Valid Name, Updating Record") + "..."
    chesscomDownloadString.value = ""
    setUserName("chesscom",chesscomName.value)
  }

  function getChesscomVerifyUser() {
    const urlStr = "https://api.chess.com/pub/player/" + chesscomName.value.toLowerCase()
    getChesscomData(urlStr,null, processChesscomVerifyUserJsonResponse) 
  }

  // ******** END DOWNLOAD ROUTINES ********
 
 </script>
 
 <style scoped>
 
 .reptree-container-background-dark {
  background-color: #403726;
  z-index : 0;
}

.reptree-container-background-light {
  background-color : #ebf2f2;
  z-index: 0;
}

.repselector-center-text {
    text-align: center;
    margin-bottom : 10px;
    font-style :italic;
  }

  .repselector-heading-color {
    background: #4c6ca0;
    color : white;
  }

  .btn-padding {
    padding: 50px;
    padding-left : 100px;
    padding-right : 100px;
  }

 </style>